import styled from 'styled-components';
import { addPxSuffix } from '@/src/helpers';

type Props = {
  $flex?: number;
  $flexShrink?: number;
  $flexGrow?: number;
  $height?: string | number;
  $width?: string | number;
  $top?: string | number;
  $bottom?: string | number;
  $left?: string | number;
  $right?: string | number;
  $zIndex?: number;
  $desktopTop?: string | number;
  $desktopLeft?: string | number;
  $desktopRight?: string | number;
};

const handlePositioning = (value: string | number | undefined) => {
  if (value === 0) return '0px';
  return addPxSuffix(value || 'auto');
};

const Absolute = styled.div<Props>`
  position: absolute;
  height: ${({ $height }) => addPxSuffix($height || 'auto')};
  width: ${({ $width }) => addPxSuffix($width || 'auto')};
  top: ${({ $top }) => handlePositioning($top)};
  bottom: ${({ $bottom }) => handlePositioning($bottom)};
  left: ${({ $left }) => handlePositioning($left)};
  right: ${({ $right }) => handlePositioning($right)};
  z-index: ${({ $zIndex }) => $zIndex ?? 0};

  @media (min-width: ${({ theme }) => theme.breakpoints.m}) {
    top: ${({ $desktopTop, $top }) => handlePositioning($desktopTop || $top)};
    left: ${({ $desktopLeft, $left }) =>
      handlePositioning($desktopLeft || $left)};
    right: ${({ $desktopRight, $right }) =>
      handlePositioning($desktopRight || $right)};
  }
`;

export default Absolute;
